var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists assessment-add-section" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "float-left col-md-10 col-12 p-0",
                    staticStyle: { "padding-left": "0", "padding-top": "5px" }
                  },
                  [
                    _c("div", { staticClass: "text-align-center" }, [
                      _vm._v(_vm._s(_vm.introduction_title) + " "),
                      _c("i", {
                        staticClass: "fa fa-pencil-square-o",
                        staticStyle: { cursor: "pointer" },
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            return _vm.editIntroductionModalAction()
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-2 padding-lr-5 float-right text-align-right",
                    staticStyle: { "padding-right": "0" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-red btn-md input-height-15 float-right text-align-right",
                        staticStyle: { height: "30px" },
                        on: {
                          click: function($event) {
                            return _vm.addSlideClick()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus spacer-icon",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" Slide")
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 override-padding" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "task-list-summary float-left col-10 override-padding",
                    staticStyle: { "padding-top": "1px" }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Introduction Summary: " +
                          _vm._s(_vm.introduction_slide_obj.slide.length) +
                          " Slides"
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                this.introduction_slide_obj.slide.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "submit float-right col-2 override-padding",
                        on: { click: _vm.onSubmit }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "col-12 btn btn-red btn-md col-12 input-height-15",
                            attrs: { type: "submit" }
                          },
                          [_vm._v("Save Introduction")]
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "loading_show"
                },
                [_c("div", { staticClass: "spinner-border text-danger" })]
              ),
              _vm._v(" "),
              _vm.introduction_slide_obj.slide.length > 0
                ? _c("div", { staticClass: "section-display" }, [
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "sortable",
                            rawName: "v-sortable",
                            value: {
                              onEnd: _vm.reorderSection,
                              handle: ".handle1"
                            },
                            expression:
                              "{onEnd: reorderSection, handle: '.handle1'}"
                          }
                        ],
                        staticClass:
                          "counter_section-list list-group col-lg-12  override-padding margin-bottom-10"
                      },
                      _vm._l(_vm.introduction_slide_obj.slide, function(
                        slide,
                        sindex
                      ) {
                        return _c(
                          "li",
                          {
                            key: slide.sortid,
                            staticClass: "list-group-item input-height-25",
                            staticStyle: { "margin-top": "10px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "section_item float-left col-12 override-padding"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 override-padding float-left"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "handle1 float-left col-lg-12 override-padding",
                                        staticStyle: { "padding-top": "2px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-left"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-arrows padding-right-5",
                                              attrs: { "aria-hidden": "true" }
                                            }),
                                            _vm._v(" "),
                                            _vm._m(1, true),
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(slide.title) +
                                                "   "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "fa fa-pencil-square-o",
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: { "aria-hidden": "true" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editSlideAction(
                                                    sindex
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-lg-2 padding-lr-5 float-right text-align-right",
                                            staticStyle: {
                                              "padding-right": "0"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-red btn-md input-height-15  text-align-right",
                                                staticStyle: { height: "30px" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.addItemClick(
                                                      sindex
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-plus spacer-icon",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(" Item")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "cursor-pointer fa fa-times",
                                              staticStyle: {
                                                "padding-left": "10px"
                                              },
                                              attrs: { "aria-hidden": "true" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteSlideConfirm(
                                                    sindex
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticStyle: { clear: "both" }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "heading_container",
                                            class:
                                              slide.item.length > 0
                                                ? "margin-bottom-5"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "heading_list" },
                                              [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "counter_heading-list list-group col-lg-12 override-padding",
                                                    attrs: { "data-id": sindex }
                                                  },
                                                  _vm._l(slide.item, function(
                                                    item,
                                                    iindex
                                                  ) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: iindex,
                                                        staticClass:
                                                          "list-group-item input-height-25",
                                                        staticStyle: {
                                                          border: "0"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "heading_item"
                                                          },
                                                          [
                                                            item.type == "Link"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "handle2 float-left  override-padding",
                                                                    staticStyle: {
                                                                      width:
                                                                        "82.66%",
                                                                      "padding-top":
                                                                        "2px",
                                                                      border:
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.type
                                                                        ) +
                                                                        " - " +
                                                                        _vm._s(
                                                                          item.image_link
                                                                        ) +
                                                                        " \n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.editAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Edit"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "View"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : item.type ==
                                                                "Button"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "handle2 float-left  override-padding",
                                                                    staticStyle: {
                                                                      width:
                                                                        "82.66%",
                                                                      "padding-top":
                                                                        "2px",
                                                                      border:
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.type
                                                                        ) +
                                                                        " - " +
                                                                        _vm._s(
                                                                          item.image_link
                                                                        ) +
                                                                        " \n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.editAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Edit"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "View"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : item.type ==
                                                                "Image"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "handle2 float-left  override-padding",
                                                                    staticStyle: {
                                                                      width:
                                                                        "82.66%",
                                                                      "padding-top":
                                                                        "2px",
                                                                      border:
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.type
                                                                        ) +
                                                                        " - " +
                                                                        _vm._s(
                                                                          item.image_link
                                                                        ) +
                                                                        "\n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.editAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Edit"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "View"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : item.type ==
                                                                  "Assessment" ||
                                                                item.type ==
                                                                  "Course"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "handle2 float-left  override-padding",
                                                                    staticStyle: {
                                                                      width:
                                                                        "82.66%",
                                                                      "padding-top":
                                                                        "2px",
                                                                      border:
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.type
                                                                        ) +
                                                                        " - " +
                                                                        _vm._s(
                                                                          item.text
                                                                        ) +
                                                                        " \n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.editAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Edit"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "View"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "handle2 float-left  override-padding",
                                                                    staticStyle: {
                                                                      width:
                                                                        "82.66%",
                                                                      "padding-top":
                                                                        "2px",
                                                                      border:
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.type
                                                                        ) +
                                                                        " - " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "stripHTML"
                                                                          )(
                                                                            item.text
                                                                          )
                                                                        ) +
                                                                        " \n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.editAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Edit"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                 - \n                                "
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          display:
                                                                            "inline",
                                                                          "text-decoration":
                                                                            "underline",
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "#00ACEE"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.viewAction(
                                                                              sindex,
                                                                              iindex
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "View"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-lg-2 padding-lr-5 float-right text-align-right",
                                                                staticStyle: {
                                                                  "padding-right":
                                                                    "0"
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "cursor-pointer fa fa-times",
                                                                  staticStyle: {
                                                                    "padding-left":
                                                                      "10px"
                                                                  },
                                                                  attrs: {
                                                                    "aria-hidden":
                                                                      "true"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.deleteItemConfirm(
                                                                        sindex,
                                                                        iindex
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "createSlideModal",
        {
          attrs: { isModalVisible: _vm.isModalVisible },
          on: {
            close: function($event) {
              _vm.isModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("New Slide")])]
          ),
          _vm._v(" "),
          _vm.isModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.slide_title,
                        expression: "slide_title"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "col-lg-12 input-text form-control",
                    staticStyle: { "line-height": "30px" },
                    attrs: {
                      name: "slide_title",
                      placeholder: "Enter Slide Title...",
                      maxlength: "255"
                    },
                    domProps: { value: _vm.slide_title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.slide_title = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.verrors.firstByRule("slide_title", "required")
                    ? _c(
                        "div",
                        { staticClass: "margin-bottom-5 validate-warning-msg" },
                        [_vm._v("Slide Title is required")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding" },
                  [
                    _c("b-form-select", {
                      staticClass: "input-text",
                      attrs: {
                        name: "slide_template",
                        options: _vm.template_options
                      },
                      model: {
                        value: _vm.slide_template,
                        callback: function($$v) {
                          _vm.slide_template = $$v
                        },
                        expression: "slide_template"
                      }
                    }),
                    _vm._v(" "),
                    _vm.verrors.firstByRule("slide_template", "required")
                      ? _c(
                          "div",
                          {
                            staticClass: "margin-bottom-5 validate-warning-msg"
                          },
                          [_vm._v("Slide Template is required")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.show_skip_button_selected,
                            expression: "show_skip_button_selected"
                          }
                        ],
                        ref: "show_skip_button",
                        staticStyle: { "margin-top": "4px" },
                        attrs: {
                          type: "checkbox",
                          id: _vm.show_skip_button,
                          name: _vm.show_skip_button
                        },
                        domProps: {
                          checked: _vm.show_skip_button_checked,
                          value: 1,
                          checked: Array.isArray(_vm.show_skip_button_selected)
                            ? _vm._i(_vm.show_skip_button_selected, 1) > -1
                            : _vm.show_skip_button_selected
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.show_skip_button_selected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = 1,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.show_skip_button_selected = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.show_skip_button_selected = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.show_skip_button_selected = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticStyle: { color: "#002F42" },
                          attrs: { for: "submit_comment_1" }
                        },
                        [_vm._v("Show Skip Button")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding text-center" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md input-height-15 col-2",
                        staticStyle: { height: "30px" },
                        on: {
                          click: function($event) {
                            return _vm.createSlide()
                          }
                        }
                      },
                      [
                        _c("b", [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" Slide")
                        ])
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "createItemModal",
        {
          attrs: { isModalVisible: _vm.isItemModalVisible },
          on: {
            close: function($event) {
              _vm.isItemModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Introduction Item")])]
          ),
          _vm._v(" "),
          _vm.isItemModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "col-12 override-padding" },
                  [
                    _c("b-form-select", {
                      staticClass: "input-text",
                      attrs: { options: _vm.item_options },
                      on: {
                        change: function($event) {
                          _vm.verrors.clear(), (_vm.verrors.items = [])
                        }
                      },
                      model: {
                        value: _vm.item_type,
                        callback: function($$v) {
                          _vm.item_type = $$v
                        },
                        expression: "item_type"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _vm.item_type == "Text"
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 override-padding assessment-intro1"
                      },
                      [
                        _c("vue-editor", {
                          ref: "textarea",
                          attrs: {
                            name: "item_text",
                            editorToolbar: _vm.customToolbar,
                            placeholder: "Enter Text"
                          },
                          on: { "text-change": _vm.introTextChange },
                          model: {
                            value: _vm.item_text,
                            callback: function($$v) {
                              _vm.item_text = $$v
                            },
                            expression: "item_text"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("item_text", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Text is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticStyle: {
                            clear: "both",
                            "margin-bottom": "50px"
                          }
                        })
                      ],
                      1
                    )
                  : _vm.item_type == "Image"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        ref: "image_file",
                        staticClass: "input-file",
                        attrs: {
                          type: "file",
                          name: "image_file",
                          accept: "image/*",
                          rules: "required"
                        },
                        on: { change: _vm.handleImage }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("image_file", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Image is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "help-text" }, [
                        _vm._v(
                          "Image should be jpg, jpeg, gif, png and size should be of 2MB"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.image_link,
                            expression: "image_link"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "image_link",
                          placeholder: "Enter Link",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.image_link },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.image_link = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("image_link", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Link is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm.item_type == "Link"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item_link,
                            expression: "item_link"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "item_link",
                          placeholder: "Enter Link",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.item_link },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.item_link = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("item_link", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Link is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item_link_text,
                            expression: "item_link_text"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "item_link_text",
                          placeholder: "Link Text",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.item_link_text },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.item_link_text = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("item_link_text", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Text is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm.item_type == "Button"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item_button_text,
                            expression: "item_button_text"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "item_button_text",
                          placeholder: "Button Text",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.item_button_text },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.item_button_text = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("item_button_text", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Button Text is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item_button_link,
                            expression: "item_button_link"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "item_button_link",
                          placeholder: "Enter Link",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.item_button_link },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.item_button_link = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("item_button_link", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Link is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm.item_type == "Assessment"
                  ? _c(
                      "div",
                      { staticClass: "col-12 override-padding" },
                      [
                        _c("b-form-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "input-text",
                          attrs: {
                            name: "assessment_selected",
                            options: _vm.assessment_options
                          },
                          on: { change: _vm.onChangeAssessmentType },
                          model: {
                            value: _vm.assessment_selected,
                            callback: function($$v) {
                              _vm.assessment_selected = $$v
                            },
                            expression: "assessment_selected"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule(
                          "assessment_selected",
                          "required"
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Assessment is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        })
                      ],
                      1
                    )
                  : _vm.item_type == "Course"
                  ? _c(
                      "div",
                      { staticClass: "col-12 override-padding" },
                      [
                        _c("b-form-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "input-text",
                          attrs: {
                            name: "course_selected",
                            options: _vm.course_options
                          },
                          on: { change: _vm.onChangeCourseType },
                          model: {
                            value: _vm.course_selected,
                            callback: function($$v) {
                              _vm.course_selected = $$v
                            },
                            expression: "course_selected"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("course_selected", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Course is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "margin-bottom-10",
                          staticStyle: { clear: "both" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding text-center" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md input-height-15 col-2",
                        staticStyle: { height: "30px" },
                        on: {
                          click: function($event) {
                            return _vm.AddItem()
                          }
                        }
                      },
                      [
                        _c("b", [
                          _c("i", {
                            staticClass: "fa fa-plus spacer-icon",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" Item")
                        ])
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "DeleteModal",
        {
          attrs: {
            isModalVisible: _vm.isDeleteModalVisible,
            id: _vm.id,
            parent_id: _vm.parent_id
          },
          on: {
            close: function($event) {
              _vm.isDeleteModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v(_vm._s(_vm.deleteMessage))]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "left col-12 btn btn-red",
                  on: {
                    click: function($event) {
                      _vm.isDeleteModalVisible = false
                      _vm.deleteAction()
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "editItemModal",
        {
          attrs: { isModalVisible: _vm.isEditItemModalVisible },
          on: {
            close: function($event) {
              _vm.isEditItemModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Edit Introduction Item")])]
          ),
          _vm._v(" "),
          _vm.isEditItemModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "col-12 override-padding" },
                  [
                    _c("b-form-select", {
                      staticClass: "input-text",
                      attrs: { options: _vm.item_options, disabled: "true" },
                      model: {
                        value: _vm.edit_item_type,
                        callback: function($$v) {
                          _vm.edit_item_type = $$v
                        },
                        expression: "edit_item_type"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _vm.edit_item_type == "Text"
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 override-padding assessment-intro"
                      },
                      [
                        _c("vue-editor", {
                          ref: "textarea",
                          attrs: {
                            name: "edit_item_text",
                            editorToolbar: _vm.customToolbar,
                            placeholder: "Enter Text"
                          },
                          on: { "text-change": _vm.introTextChange },
                          model: {
                            value: _vm.edit_item_text,
                            callback: function($$v) {
                              _vm.edit_item_text = $$v
                            },
                            expression: "edit_item_text"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("edit_item_text", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Text is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticStyle: {
                            clear: "both",
                            "margin-bottom": "50px"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.edit_item_type == "Image"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _vm.edit_image_file == ""
                        ? _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "edit_image_file",
                              staticClass: "input-file",
                              attrs: {
                                type: "file",
                                name: "edit_image_file",
                                accept: "image/*",
                                rules: "required"
                              },
                              on: { change: _vm.handleEditImage }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "help-text" }, [
                              _vm._v(
                                "Image should be jpg, jpeg, gif, png and size should be of 2MB"
                              )
                            ]),
                            _vm._v(" "),
                            _vm.verrors.firstByRule(
                              "edit_image_file",
                              "required"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "margin-bottom-5 validate-warning-msg"
                                  },
                                  [_vm._v("Image is required")]
                                )
                              : _vm._e()
                          ])
                        : _c("div", [
                            _c("div", { staticClass: "col-12 p-0" }, [
                              _c(
                                "div",
                                { staticClass: "col-3 p-0 float-left" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.edit_image_file,
                                      width: "100",
                                      height: "100"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-6 p-0 float-left",
                                  staticStyle: { "margin-top": "35px" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-red btn-md input-height-15 col-4",
                                      staticStyle: { height: "30px" },
                                      on: {
                                        click: function($event) {
                                          return _vm.RemoveImage()
                                        }
                                      }
                                    },
                                    [_c("b", [_vm._v("Remove")])]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticStyle: { clear: "both" } })
                            ])
                          ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_image_link,
                            expression: "edit_image_link"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "edit_image_link",
                          placeholder: "Enter Link...",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_image_link },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_image_link = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("edit_image_link", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Link is required")]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _vm.edit_item_type == "Link"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_item_link,
                            expression: "edit_item_link"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "edit_item_link",
                          placeholder: "Enter Link",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_item_link },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_item_link = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("edit_item_link", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Link is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_item_link_text,
                            expression: "edit_item_link_text"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "edit_item_link_text",
                          placeholder: "Link Text",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_item_link_text },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_item_link_text = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("edit_item_link_text", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Text is required")]
                          )
                        : _vm._e()
                    ])
                  : _vm.edit_item_type == "Button"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_item_button_text,
                            expression: "edit_item_button_text"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "edit_item_button_text",
                          placeholder: "Button Text",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_item_button_text },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_item_button_text = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule(
                        "edit_item_button_text",
                        "required"
                      )
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Button Text is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_item_button_link,
                            expression: "edit_item_button_link"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "col-lg-12 input-text form-control",
                        staticStyle: { "line-height": "30px" },
                        attrs: {
                          name: "edit_item_button_link",
                          placeholder: "Enter Link",
                          maxlength: "255"
                        },
                        domProps: { value: _vm.edit_item_button_link },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.edit_item_button_link = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule(
                        "edit_item_button_link",
                        "required"
                      )
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Link is required")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _vm.edit_item_type == "Assessment"
                  ? _c(
                      "div",
                      { staticClass: "col-12 override-padding" },
                      [
                        _c("b-form-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "input-text",
                          attrs: {
                            name: "edit_assessment_selected",
                            options: _vm.assessment_options
                          },
                          on: { change: _vm.onEditChangeAssessmentType },
                          model: {
                            value: _vm.edit_assessment_selected,
                            callback: function($$v) {
                              _vm.edit_assessment_selected = $$v
                            },
                            expression: "edit_assessment_selected"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule(
                          "edit_assessment_selected",
                          "required"
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Assessment is required")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _vm.edit_item_type == "Course"
                  ? _c(
                      "div",
                      { staticClass: "col-12 override-padding" },
                      [
                        _c("b-form-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "input-text",
                          attrs: {
                            name: "edit_course_selected",
                            options: _vm.course_options
                          },
                          on: { change: _vm.onEditChangeCourseType },
                          model: {
                            value: _vm.edit_course_selected,
                            callback: function($$v) {
                              _vm.edit_course_selected = $$v
                            },
                            expression: "edit_course_selected"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule(
                          "edit_course_selected",
                          "required"
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Course is required")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding text-center" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md input-height-15 col-2",
                        staticStyle: { height: "30px" },
                        on: {
                          click: function($event) {
                            return _vm.EditItem()
                          }
                        }
                      },
                      [_c("b", [_vm._v("Save")])]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "editSlideModal",
        {
          attrs: { isModalVisible: _vm.isEditModalVisible },
          on: {
            close: function($event) {
              _vm.isEditModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Edit Slide")])]
          ),
          _vm._v(" "),
          _vm.isEditModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.edit_slide_title,
                        expression: "edit_slide_title"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "col-lg-12 input-text form-control",
                    staticStyle: { "line-height": "30px" },
                    attrs: {
                      name: "edit_slide_title",
                      placeholder: "Enter Slide Title...",
                      maxlength: "255"
                    },
                    domProps: { value: _vm.edit_slide_title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.edit_slide_title = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.verrors.firstByRule("edit_slide_title", "required")
                    ? _c(
                        "div",
                        { staticClass: "margin-bottom-5 validate-warning-msg" },
                        [_vm._v("Slide Title is required")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding" },
                  [
                    _c("b-form-select", {
                      staticClass: "input-text",
                      attrs: {
                        name: "edit_slide_template",
                        options: _vm.template_options
                      },
                      model: {
                        value: _vm.edit_slide_template,
                        callback: function($$v) {
                          _vm.edit_slide_template = $$v
                        },
                        expression: "edit_slide_template"
                      }
                    }),
                    _vm._v(" "),
                    _vm.verrors.firstByRule("edit_slide_template", "required")
                      ? _c(
                          "div",
                          {
                            staticClass: "margin-bottom-5 validate-warning-msg"
                          },
                          [_vm._v("Slide Template is required")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.edit_show_skip_button_selected,
                            expression: "edit_show_skip_button_selected"
                          }
                        ],
                        ref: "edit_show_skip_button",
                        staticStyle: { "margin-top": "4px" },
                        attrs: {
                          type: "checkbox",
                          id: _vm.edit_show_skip_button,
                          name: _vm.edit_show_skip_button
                        },
                        domProps: {
                          checked: _vm.edit_show_skip_button_checked,
                          value: 1,
                          checked: Array.isArray(
                            _vm.edit_show_skip_button_selected
                          )
                            ? _vm._i(_vm.edit_show_skip_button_selected, 1) > -1
                            : _vm.edit_show_skip_button_selected
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.edit_show_skip_button_selected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = 1,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.edit_show_skip_button_selected = $$a.concat(
                                    [$$v]
                                  ))
                              } else {
                                $$i > -1 &&
                                  (_vm.edit_show_skip_button_selected = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.edit_show_skip_button_selected = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticStyle: { color: "#002F42" },
                          attrs: { for: "submit_comment_1" }
                        },
                        [_vm._v("Show Skip Button")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding text-center" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md input-height-15 col-2",
                        staticStyle: { height: "30px" },
                        on: {
                          click: function($event) {
                            return _vm.EditSlide()
                          }
                        }
                      },
                      [_c("b", [_vm._v("Save")])]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "editIntroductionModal",
        {
          attrs: { isModalVisible: _vm.isEditIntroModalVisible },
          on: {
            close: function($event) {
              _vm.isEditIntroModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Edit Introduction")])]
          ),
          _vm._v(" "),
          _vm.isEditIntroModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.introduction_title,
                        expression: "introduction_title"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "col-lg-12 input-text form-control",
                    staticStyle: { "line-height": "30px" },
                    attrs: {
                      name: "introduction_title",
                      placeholder: "Enter Title...",
                      maxlength: "255"
                    },
                    domProps: { value: _vm.introduction_title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.introduction_title = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.verrors.firstByRule("introduction_title", "required")
                    ? _c(
                        "div",
                        { staticClass: "margin-bottom-5 validate-warning-msg" },
                        [_vm._v("Introduction Manager Title is required")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("multiselect", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          options: _vm.affiliate_options,
                          "track-by": "name",
                          label: "name",
                          placeholder: "Select Affiliates...",
                          multiple: true,
                          "close-on-select": false,
                          "show-labels": false,
                          name: "affiliate",
                          id: "affiliate"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          _vm._s(values.length) + " selected"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.affiliate_selected,
                          callback: function($$v) {
                            _vm.affiliate_selected = $$v
                          },
                          expression: "affiliate_selected"
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("affiliate", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Affilates is required")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("multiselect", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          options: _vm.roles_options,
                          "track-by": "name",
                          label: "name",
                          placeholder: "Select Users...",
                          multiple: true,
                          "close-on-select": false,
                          "show-labels": false,
                          name: "roles",
                          id: "roles"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function(ref) {
                              var values = ref.values
                              var search = ref.search
                              var isOpen = ref.isOpen
                              return [
                                values.length && !isOpen
                                  ? _c(
                                      "span",
                                      { staticClass: "multiselect__single" },
                                      [
                                        _vm._v(
                                          _vm._s(values.length) + " selected"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.roles_selected,
                          callback: function($$v) {
                            _vm.roles_selected = $$v
                          },
                          expression: "roles_selected"
                        }
                      }),
                      _vm._v(" "),
                      _vm.verrors.firstByRule("roles", "required")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "margin-bottom-5 validate-warning-msg"
                            },
                            [_vm._v("Users is required")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search-padd",
                      attrs: { id: "mentee-group-wrapper" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.show_slide_number_selected,
                            expression: "show_slide_number_selected"
                          }
                        ],
                        ref: "show_slide_number",
                        staticStyle: { "margin-top": "4px" },
                        attrs: {
                          type: "checkbox",
                          id: _vm.show_slide_number,
                          name: _vm.show_slide_number
                        },
                        domProps: {
                          checked: _vm.show_slide_number_checked,
                          value: 1,
                          checked: Array.isArray(_vm.show_slide_number_selected)
                            ? _vm._i(_vm.show_slide_number_selected, 1) > -1
                            : _vm.show_slide_number_selected
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.show_slide_number_selected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = 1,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.show_slide_number_selected = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.show_slide_number_selected = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.show_slide_number_selected = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticStyle: { color: "#002F42" },
                          attrs: { for: "submit_comment_1" }
                        },
                        [_vm._v("Show Slide Numbers")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-red btn-md input-height-15 col-2",
                        staticStyle: { height: "30px" },
                        on: {
                          click: function($event) {
                            return _vm.editIntroduction()
                          }
                        }
                      },
                      [_c("b", [_vm._v("Save")])]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "viewItemModal",
        {
          attrs: { isModalVisible: _vm.isViewItemModalVisible },
          on: {
            close: function($event) {
              _vm.isViewItemModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("View Introduction Item")])]
          ),
          _vm._v(" "),
          _vm.isViewItemModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                this.introduction_slide_obj.slide[this.editSlideIndexValue]
                  .item[this.editItemIndexValue].type == "Image"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].type
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _c("img", {
                          attrs: {
                            src: this.introduction_slide_obj.slide[
                              this.editSlideIndexValue
                            ].item[this.editItemIndexValue].image,
                            height: "250",
                            width: "250"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].image_link
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.introduction_slide_obj.slide[this.editSlideIndexValue]
                  .item[this.editItemIndexValue].type == "Link"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].type
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].text
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].image_link
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.introduction_slide_obj.slide[this.editSlideIndexValue]
                  .item[this.editItemIndexValue].type == "Button"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].type
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].text
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].image_link
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.introduction_slide_obj.slide[this.editSlideIndexValue]
                  .item[this.editItemIndexValue].type == "Assessment" ||
                this.introduction_slide_obj.slide[this.editSlideIndexValue]
                  .item[this.editItemIndexValue].type == "Course"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].type
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].text
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.introduction_slide_obj.slide[this.editSlideIndexValue]
                  .item[this.editItemIndexValue].type == "Text"
                  ? _c("div", { staticClass: "col-12 override-padding" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              this.introduction_slide_obj.slide[
                                this.editSlideIndexValue
                              ].item[this.editItemIndexValue].type
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "col-12 override-padding",
                        domProps: {
                          innerHTML: _vm._s(
                            this.introduction_slide_obj.slide[
                              this.editSlideIndexValue
                            ].item[this.editItemIndexValue].text
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "d-inline heading" }, [
        _vm._v("Edit Introduction")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { "font-weight": "bold" } }, [
      _c("span", { staticClass: "counter_section-list__counter" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c51a6b36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c51a6b36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/introduction_add_slides.vue
// module id = null
// module chunks = 